<template>
  <el-dialog
      :title="$t('socialPosts.create.confirmDraft.title')"
      :visible.sync="modalVisible"
      width="45%"
      @close="handleClose">
    <span class="text-left">
      {{ $t('socialPosts.create.confirmDraft.message')}}
    </span>
    <span slot="footer" class="dialog-footer">
      <el-button type="success" @click="handleConfirm">{{ $t('socialPosts.create.confirmDraft.confirm')}}</el-button>
      <el-button @click="handleClose">{{ $t('socialPosts.create.confirmDraft.cancel')}}</el-button>
    </span>
  </el-dialog>
</template>

<script>
export default {
  name: 'DialogConfirmDraft',
  props: {
    visible: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    modalVisible: {
      get() {
        return this.visible
      },
      set(value) {
        if (!value) {
          this.$emit('update:visible', false)
        }
      }
    }
  },
  methods: {
    handleConfirm() {
      // Ne pas fermer la modale ici, laisser le parent le gérer
      // pour éviter les conflits avec le loader
      this.$emit('confirm')
    },
    handleClose() {
      this.$emit('cancel')
    }
  }
}
</script>

<style scoped>
.dialog-footer {
  display: flex;
  justify-content: flex-end;
}
</style>

